
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class AuthorizeDialog extends Serenity.PropertyDialog<any, any>
    {

        protected form = new AuthorizeForm(this.idPrefix);
        public entityId: number;
        public inst;
        constructor() {
            super();

            this.form = new AuthorizeForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Authorize";
        } 
        protected getDialogButtons(){
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.Username.value == null ||
                            Q.isEmptyOrNull(this.form.Username.value)) {
                            Q.notifyError("Please Enter Username!");
                            return;
                        }
                        if (this.form.Password.value == null ||
                            Q.isEmptyOrNull(this.form.Password.value)) {
                            Q.notifyError("Please Enter Password!");
                            return;
                        }

                        BranchInService.Custom({
                            Username: this.form.Username.value.toString(),
                            Password: this.form.Password.value.toString(),
                            EntityId: this.entityId
                        }, response => {
                            //Q.notifyInfo(
                            //    'Inserted: ' + (response.Inserted || 0) +
                            //    ', Updated: ' + (response.Updated || 0));

                            //if (response.ErrorList != null && response.ErrorList.length > 0) {
                            //    Q.notifyError(response.ErrorList.join(',\r\n '));
                            //}
                            window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Authorized!',
                                    text: 'Voucher Authorized',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            );
                            this.dialogClose();
                            this.inst.dialogClose();
                            return true;
                        }, { async: false });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}